import React, { useState } from 'react';
import { ImageDown, Check } from 'lucide-react';

function wrapText(ctx, text, maxWidth) {
  const words = text.split(' ');
  const lines = [];
  let line = '';
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else {
      line = test;
    }
  }
  if (line) lines.push(line);
  return lines;
}

function drawBadgeCard(badge, userName) {
  const S = 1080;
  const canvas = document.createElement('canvas');
  canvas.width = S;
  canvas.height = S;
  const ctx = canvas.getContext('2d');

  const grad = ctx.createLinearGradient(0, 0, S, S);
  grad.addColorStop(0, '#1A4331');
  grad.addColorStop(0.6, '#2E5C46');
  grad.addColorStop(1, '#3E4A2E');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, S, S);

  ctx.strokeStyle = 'rgba(201,168,91,0.55)';
  ctx.lineWidth = 3;
  ctx.strokeRect(40, 40, S - 80, S - 80);

  ctx.textAlign = 'center';
  ctx.fillStyle = '#C9A85B';
  ctx.font = '600 34px Outfit, sans-serif';
  ctx.fillText('H O M E G R O W N', S / 2, 130);

  ctx.fillStyle = '#C66B4A';
  ctx.font = '700 38px Outfit, sans-serif';
  ctx.fillText('✦ BADGE UNLOCKED ✦', S / 2, 200);

  // Gold ring behind icon
  ctx.beginPath();
  ctx.arc(S / 2, 400, 130, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(201,168,91,0.15)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(S / 2, 400, 130, 0, Math.PI * 2);
  ctx.strokeStyle = '#C9A85B';
  ctx.lineWidth = 5;
  ctx.stroke();

  ctx.font = '150px serif';
  ctx.fillText(badge.icon, S / 2, 455);

  ctx.fillStyle = '#FAF6EC';
  ctx.font = '700 72px Outfit, sans-serif';
  ctx.fillText(badge.title, S / 2, 630);

  ctx.fillStyle = 'rgba(250,246,236,0.85)';
  ctx.font = '500 33px Manrope, sans-serif';
  wrapText(ctx, badge.description, S - 260).slice(0, 2).forEach((l, i) => ctx.fillText(l, S / 2, 695 + i * 45));

  ctx.fillStyle = '#C9A85B';
  ctx.font = '700 44px Outfit, sans-serif';
  ctx.fillText(`+${badge.xp_reward} XP`, S / 2, 830);

  const when = badge.unlocked_at
    ? new Date(badge.unlocked_at).toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';
  ctx.fillStyle = 'rgba(250,246,236,0.8)';
  ctx.font = '500 30px Manrope, sans-serif';
  ctx.fillText(`Earned by ${userName}${when ? ` · ${when}` : ''}`, S / 2, 900);

  ctx.fillStyle = 'rgba(250,246,236,0.55)';
  ctx.font = '500 26px Manrope, sans-serif';
  ctx.fillText('Grow your own · homegrown', S / 2, S - 70);
  return canvas;
}

export function BadgeShareButton({ badge, userName }) {
  const [saved, setSaved] = useState(false);

  const share = async (e) => {
    e.stopPropagation();
    try { await document.fonts.ready; } catch (err) { console.error(err); }
    const canvas = drawBadgeCard(badge, userName || 'a Homegrown grower');
    canvas.toBlob(async (blob) => {
      if (!blob) return;
      const file = new File([blob], `homegrown-badge-${badge.achievement_id}.png`, { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({ files: [file], title: `Badge unlocked: ${badge.title}`, text: `I just unlocked "${badge.title}" on Homegrown 🌱` });
          setSaved(true);
          setTimeout(() => setSaved(false), 2500);
          return;
        } catch (err) { console.error(err); }
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `homegrown-badge-${badge.achievement_id}.png`;
      a.click();
      URL.revokeObjectURL(url);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    }, 'image/png');
  };

  return (
    <button onClick={share} data-testid={`share-badge-${badge.achievement_id}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#C9A85B] hover:text-[#B0934E] mt-2">
      {saved ? <><Check className="w-3.5 h-3.5" /> Saved!</> : <><ImageDown className="w-3.5 h-3.5" /> Share as picture</>}
    </button>
  );
}
